import React from 'react';
import { Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import LoadingCircle from '@cpg-its/ads.common.loading-circle';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { useClergyBioSettings } from './useClergyBioSettings';
import ClergyBioInfoHeader from './components/clergy-bio-info-header';
import { ClergyBioNav } from './components/clergy-bio-nav';
import { ClergyBioRoutes } from './model/clergy-bio-app-models';
import { TcsmStates } from '../../root/tcsm-model';
import { useClergyBioInfo } from './useClergyBioInfo';
import ClergyBioSummary from './summary/clergy-bio-summary';
import ClergyBioPersonalInfoUpdate from './personal-info/clergy-bio-personal-update';
import ClergyBioChurchReportingUpdate from './church-reporting/clergy-bio-church-reporting-update';
import { PageContainer } from '../../global/components/layout/page-container';
import { MainContent } from '../../global/components/layout/main-content-container';
import { InfoBarWrapper } from '../../global/components/layout/info-bar-wrapper';
import ClergyBioRelationshipUpdate from './relationships/clergy-bio-relationship-update';
import ClergyBioEducationUpdate from './education/clergy-bio-education-update';
import ClergyBioMinistriesUpdate from './ministries/clergy-bio-ministries-update';
import ClergyBioProfessionalUpdate from './professional/clergy-bio-professional-update';
import ClergyBioVolunteerUpdate from './volunteer/clergy-bio-volunteer-update';
import { RouteBreadcrumb } from '../../global/models/epi-model';
import { Breadcrumbs } from '../../global/components/breadcrumbs';

interface Props {
	settingsId: string;
}

function ClergyBioApp(props: Props) {

	const settingsLoaded = useClergyBioSettings(props.settingsId);
	const guid = useSelector<TcsmStates, string>(state => state.authenticatedState?.clientGuid);
	const routeMatch = useRouteMatch();
	useClergyBioInfo(guid);

	const routeBreadcrumbs = useSelector<TcsmStates, RouteBreadcrumb[]>(state => state.epiProps?.siteSettingsState?.siteSettings?.routeBreadcrumbs);

	if (!settingsLoaded) {
		return <LoadingCircle />;
	}

	return (
		<>
			<Breadcrumbs routeBreadcrumbs={routeBreadcrumbs} />
			<InfoBarWrapper>
				<ClergyBioInfoHeader />
				<Grid item md={4} className='infobar-nav'>
					<ClergyBioNav basePath={routeMatch.path} />
				</Grid>
			</InfoBarWrapper>
			<PageContainer>
				<MainContent>
					<Switch>
						<Route exact path={`${routeMatch.path}`}>
							<Redirect to={`${routeMatch.path}${ClergyBioRoutes.Summary}`} />
						</Route>
						<Route exact path={`${routeMatch.path}${ClergyBioRoutes.Summary}`} render={() => <ClergyBioSummary basePath={routeMatch.path} />} />
						<Route exact path={`${routeMatch.path}${ClergyBioRoutes.Personal}`} render={() => <ClergyBioPersonalInfoUpdate />} />
						<Route exact path={`${routeMatch.path}${ClergyBioRoutes.ChurchReporting}`} render={() => <ClergyBioChurchReportingUpdate />} />
						<Route exact path={`${routeMatch.path}${ClergyBioRoutes.Relationships}`} render={() => <ClergyBioRelationshipUpdate />} />
						<Route exact path={`${routeMatch.path}${ClergyBioRoutes.Education}`} render={() => <ClergyBioEducationUpdate />} />
						<Route exact path={`${routeMatch.path}${ClergyBioRoutes.Ministry}`} render={() => <ClergyBioMinistriesUpdate />} />
						<Route exact path={`${routeMatch.path}${ClergyBioRoutes.Professional}`} render={() => <ClergyBioProfessionalUpdate />} />
						<Route exact path={`${routeMatch.path}${ClergyBioRoutes.Volunteer}`} render={() => <ClergyBioVolunteerUpdate />} />
					</Switch>
				</MainContent>
			</PageContainer>
		</>
	);
}

ClergyBioApp.defaultProps = {

};


export default ClergyBioApp;